import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";
import { observer } from "mobx-react";
import { LeadSourceEnum } from "enums/lead-source.enum";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { AccountLeadStore } from "store/UserAccounts/UserAccount/AccountLeads/AccountLead.store";

interface IProps {
  accountStore: UserAccountStore;
  leadStore: AccountLeadStore;
}

export const LeadCreatedEventContent: FC<IProps> = observer(
  ({ accountStore, leadStore }) => {
    const source = leadStore.lead.source;

    const label = useMemo(() => {
      if (source === LeadSourceEnum.nurtur_grs) {
        const {
          name,
        } = accountStore.accountLeadSourcesStore.getSourceNameAndUrlFromSource(
          source
        );
        return `Created from ${name}`;
      }

      return "Manually created";
    }, [source, accountStore]);

    return (
      <Box fontSize={"sm"} color={"gray.500"}>
        {label}
      </Box>
    );
  }
);
